export default __webpack_public_path__ + "static/media/PendingApproval.dda1e510.svg";